import { render } from "./PopUp.vue?vue&type=template&id=77f37372"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=77f37372&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__